// extracted by mini-css-extract-plugin
module.exports = {"sectionContact":"ContactOther_sectionContact_z7QQt","contactBox":"ContactOther_contactBox_L915P","formDetail":"ContactOther_formDetail_KGX42"};